import { ProgressBar } from '@welbe/web-design-system';
import React from 'react';
import { tokens } from 'styles/tokens';
import { ContainerDonut } from './ProgressBarInfo.styles';

interface PeogressBarInfoProps {
	percent?: any;
	labelText?: any;
	title?: any;
	answered?: any;
	total?: any;
	description?: any;
	color?: any;
}

export const ProgressBarInfo = ({
	percent,
	labelText,
	title,
	answered,
	total,
	description,
	color,
}: PeogressBarInfoProps) => {
	const labelSize = labelText === 'Muy alto' ? '9px' : '12px';
	const percentSize = '18px';

	return (
		<ContainerDonut>
			<ProgressBar
				percentValue={percent}
				isDonut
				donutSize="86px"
				progressColor={color}
				backgroundColor="#D8DEE6"
				labelColor={tokens.color_gray_dark}
				labelFontSize={labelText ? labelSize : percentSize}
				labelText={labelText}
				hasLabel
			/>
			<h3>
				{title ? (
					<b>{title}</b>
				) : (
					<>
						<b>{answered}</b> de {total}
					</>
				)}
			</h3>
			<h4>{description}</h4>
		</ContainerDonut>
	);
};
